/**
 * The top bar: where the user is in the task (the pack's steps, the current one highlighted, the done
 * ones checked), at the left the session id (tap: copy) or, in a replay or with an operator, whose
 * screen this is; at the right the Settings gear.
 */
import { STEP_DONE } from '../../packs/contract';
import { useApp } from '../../react/app';
import { useScreen, useTranslate } from '../../react/hooks';
import { RoleLabel } from '../../shell/RoleLabel';
import { SessionChip } from '../../shell/SessionChip';
import { useUiActions } from '../../shell/useUiActions';
import { Icon } from '../../ui-kit/Icon';
import css from './Progress.module.css';

export function ProgressModule() {
  const app = useApp();
  const { pack } = app;
  const screen = useScreen();
  const t = useTranslate();
  const actions = useUiActions();
  const steps = pack.steps;
  const current = steps.findIndex((s) => s.id === screen.def?.step);
  const finished = screen.def?.step === STEP_DONE;

  return (
    <div className={css.bar}>
      {app.kiosk.role === 'kiosk' ? <SessionChip className={css.role} /> : <RoleLabel className={css.role} compact />}
    <nav className={css.progress} aria-label="progress">
      {steps.map((step, i) => {
        const done = finished || (current !== -1 && i < current);
        const active = i === current;
        return (
          <div key={step.id} className={`${css.step} ${done ? css.done : ''} ${active ? css.active : ''}`} aria-current={active ? 'step' : undefined}>
            <span className={css.dot}>{done ? <Icon name="check" size={14} strokeWidth={3.5} /> : i + 1}</span>
            <span className={css.label}>{t(step.label)}</span>
          </div>
        );
      })}
    </nav>
      <button className={css.settings} onClick={() => actions.toggleSettings()} aria-label={t('settings.title')}>
        <Icon name="settings" size={30} />
      </button>
    </div>
  );
}
